import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "payPalStubsModal" */ './PayPalStubsModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'PayPalStubsModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PayPalStubsModal };
